import axios from "../auth/jwt/config"
export default axios
